module.exports = __webpack_public_path__ + "img/1473205806.a10dd73c.jpg";